import { Injectable } from '@angular/core';
import { InlineAddConfig } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class StockClassAddConfigService {
  getStockClassConfig(): InlineAddConfig {
    return {
      modelType: 'stockclass',
      title: 'Stock Class',
      apiEndpoint: 'api/stockclasses/create',
      hiddenData: {
        isActive: true,
      },
      fields: [
        {
          name: 'code',
          label: 'Stock Class Code',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 50,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter class name',
          size: 'half'
        },
        
      ],
      selectionConfig: {
        targetField: 'stockClassId',
        valueField: 'id',
        labelField: 'code'
      },
      showMoreDetails: false
    };
  }
}
